import React, { useState, useEffect } from 'react';
import { string, oneOf } from 'prop-types';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { useDataModel, params, string as stringType, shape, } from '@thd-nucleus/data-sources';
import classNames from 'classnames/bind';
import styles from './product-identifier.module.scss';

const cx = classNames.bind(styles);

export const ProductIdentifier = ({ itemId, type }) => {
  const [identifier, setIdentifier] = useState(null);
  const { data, loading, error } = useDataModel('product', {
    variables: {
      itemId
    }
  });

  const { identifiers } = data?.product || {};
  const { modelNumber, itemId: itemIdFromData, storeSkuNumber } = identifiers || {};

  const getIdentifierValue = (key) => {
    const identifierValues = {
      model: modelNumber,
      storeSku: storeSkuNumber,
      itemId: itemIdFromData
    };
    return identifierValues[key] || null;
  };
  const IDENTIFIER_LABEL = {
    model: 'Model#', storeSku: 'StoreSKU#', itemId: 'Internet#'
  };

  useEffect(() => {
    if (identifiers) {
      setIdentifier(getIdentifierValue(type));
    }
  }, [identifiers, type]);

  const value = getIdentifierValue(type) || identifier;
  if (loading && !data) return <Placeholder type="text" />;
  if ((error && !data) || !value) return null;

  const label = `${IDENTIFIER_LABEL[type]} ${value}`;
  return (
    <div className={cx('product-identifier')}>{label}</div>
  );
};

ProductIdentifier.displayName = 'ProductIdentifier';

ProductIdentifier.propTypes = {
  itemId: string.isRequired,
  type: oneOf(['storeSku', 'model', 'itemId']).isRequired,
};

ProductIdentifier.dataModel = {
  product: params({
    itemId: stringType().isRequired(),
    dataSource: stringType()
  }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    identifiers: shape({
      modelNumber: stringType(),
      storeSkuNumber: stringType(),
      itemId: stringType()
    })
  })
};
